// src/components/reports/SummaryReportModal.jsx
import React from "react";
import * as XLSX from "xlsx";
import styles from "./SummaryReportModal.module.css";

function formatDateDMY(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = String(d.getFullYear()).slice(-2);
  return `${dd}.${mm}.${yy}`;
}

export default function SummaryReportModal({ visible, onClose, route }) {
  if (!visible || !route) return null;

  // Оставляем только "Открытые" квитанции
  const receipts = (route.receipts || []).filter(r => r.status === "Открыта");

  const exportToExcel = () => {
    // <1> Заголовки Excel (AOA)
    const headerRow1 = ["№ квитанции", "Статус", "Чек распечатан", "Адрес", "Клиент", "Позиции"];
    const tableRows = receipts.map(r => {
      const positions = r.products
        .filter(p => p.is_marked)
        .map(p => `${p.product_name}: ${(p.marks || []).length}/${p.actual_quantity}`)
        .join("; ");
      return [
        r.receipt_number,
        r.status,
        r.is_check_issued ? "Да" : "Нет",
        r.delivery_address || "",
        r.client_name || "",
        positions
      ];
    });
    const aoa = [headerRow1, ...tableRows];

    // <2> Создаём лист и книгу
    const ws = XLSX.utils.aoa_to_sheet(aoa);
    ws["!cols"] = [
      { wch: 15 }, // № квитанции
      { wch: 12 }, // Статус
      { wch: 12 }, // Чек распечатан
      { wch: 30 }, // Адрес
      { wch: 20 }, // Клиент
      { wch: 50 }  // Позиции
    ];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, `Route_${route.route_number}`);

    // <3> Сохраняем файл
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `route_${route.route_number}_receipts.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <header className={styles.header}>
          <h2>Детализация маршрута №{route.route_number}</h2>
          <button className={styles.closeBtn} onClick={onClose}>✕</button>
        </header>

        <div className={styles.routeInfo}>
          <div><strong>Дата:</strong><br />{formatDateDMY(route.route_date)}</div>
          <div><strong>Водитель:</strong><br />{route.driver || "-"}</div>
          <div><strong>Грузчик 1:</strong><br />{route.loader1 || "-"}</div>
          <div><strong>Грузчик 2:</strong><br />{route.loader2 || "-"}</div>
        </div>

        <button
          className={styles.exportBtn}
          onClick={exportToExcel}
          disabled={receipts.length === 0}
        >
          Скачать Excel
        </button>

        {receipts.length === 0 ? (
          <div className={styles.noData}>Нет открытых квитанций.</div>
        ) : (
          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>№ квитанции</th>
                  <th>Статус</th>
                  <th>Чек пробит</th>
                  <th>Адрес</th>
                  <th>Клиент</th>
                  <th>Позиции (скан/всего)</th>
                </tr>
              </thead>
              <tbody>
                {receipts.map(r => {
                  const positions = r.products
                    .filter(p => p.is_marked)
                    .map(p => `${p.product_name}: ${(p.marks||[]).length}/${p.actual_quantity}`)
                    .join("; ");
                  return (
                    <tr key={r.id}>
                      <td>{r.receipt_number}</td>
                      <td>{r.status}</td>
                      <td>{r.is_check_issued ? "Да" : "Нет"}</td>
                      <td>{r.delivery_address || "-"}</td>
                      <td>{r.client_name || "-"}</td>
                      <td>{positions}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
